<template>
  <div>
    <b-alert
      :variant="alertData.variant"
      :show="dismissCountDown"
      dismissible
      fade
      class="mb-1"
      @dismiss-count-down="countDownChanged"
    >
      <div class="alert-body">
        <span><strong>{{ alertData.strongText }}</strong> {{ alertData.lightText }}</span>
      </div>
    </b-alert>
    <b-overlay :show="saving">
      <validation-observer
        ref="form"
        #default="{invalid}"
      >
        <form @submit.prevent="onSubmit">
          <b-card
            footer-class="text-muted"
            body-class="p-0"
          >
            <b-tabs
              v-model="tabIndex"
              pills
              nav-class="mb-3 pt-2 pr-2 pl-2"
            >
              <b-tab button-id="project">
                <template #title>
                  <feather-icon
                    class="mr-1"
                    icon="AlertCircleIcon"
                  /> {{ $t('projectUpsertForm.project.title') }}
                </template>

                <b-row class="p-2">
                  <b-col sm="6" md="6" lg="6">
                    <image-input
                      v-model="form.pictureUrl"
                      :upload-label="$t('projectUpsertForm.project.pictureUrl')"
                      :size-label="$t('projectUpsertForm.project.pictureUrlPhotosize')"
                      :instructions-label="$t('projectUpsertForm.project.pictureUrlInstructions')"
                      :show-delete-button="false"
                      :max-size="(2 ** 25)"
                      @change="(value) => { form.pictureUrl = value }"
                    />
                  </b-col>
                </b-row>

                <b-row class="p-2">
                  <b-col sm="6" md="6" lg="6">
                    <b-form-group :label="$t('projectUpsertForm.project.name')">
                      <validation-provider
                        #default="{ errors }"
                        :name="$t('projectUpsertForm.project.name')"
                        vid="name"
                        rules="required"
                      >
                        <b-form-input
                          v-model="form.autor"
                          name="autor"
                          :class="errors.length > 0 ? 'is-invalid' : null"
                          :placeholder="$t('projectUpsertForm.project.namePlaceholder')"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col sm="6" md="6" lg="6">
                    <b-form-group :label="$t('projectUpsertForm.project.titular')">
                      <validation-provider
                        #default="{ errors }"
                        :name="$t('projectUpsertForm.project.titular')"
                        vid="titular"
                        rules="required"
                      >
                        <b-form-input
                          v-model="form.titular"
                          name="titular"
                          :class="errors.length > 0 ? 'is-invalid' : null"
                          :placeholder="$t('projectUpsertForm.project.titularPlaceholder')"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row class="p-2">
                  <b-col sm="6" md="6" lg="6">
                    <b-form-group :label="$t('projectUpsertForm.project.supervisor')">
                      <validation-provider
                        #default="{ errors }"
                        :name="$t('projectUpsertForm.project.supervisor')"
                        vid="supervisor"
                        rules="required"
                      >
                        <b-form-input
                          v-model="form.supervisor"
                          name="supervisor"
                          :class="errors.length > 0 ? 'is-invalid' : null"
                          :placeholder="$t('projectUpsertForm.project.supervisorPlaceholder')"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col sm="6" md="6" lg="6">
                    <b-form-group :label="$t('projectUpsertForm.project.technician')">
                      <validation-provider
                        #default="{ errors }"
                        :name="$t('projectUpsertForm.project.technician')"
                        vid="technician"
                        rules="required"
                      >
                        <b-form-input
                          v-model="form.technician"
                          name="technician"
                          :class="errors.length > 0 ? 'is-invalid' : null"
                          :placeholder="$t('projectUpsertForm.project.technicianPlaceholder')"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row class="p-2">
                  <b-col sm="6" md="6" lg="6">
                    <b-form-group :label="$t('projectUpsertForm.project.proposito')">
                      <validation-provider
                        #default="{ errors }"
                        :name="$t('projectUpsertForm.project.proposito')"
                        vid="proposito"
                        rules="required"
                      >
                        <b-form-input
                          v-model="form.proposito"
                          name="proposito"
                          :class="errors.length > 0 ? 'is-invalid' : null"
                          :placeholder="$t('projectUpsertForm.project.propositoPlaceholder')"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col sm="6" md="6" lg="6">
                    <b-form-group :label="$t('projectUpsertForm.project.tipo')">
                      <validation-provider
                        #default="{ errors }"
                        :name="$t('projectUpsertForm.project.tipo')"
                        vid="tipo"
                        rules="required"
                      >
                        <b-form-input
                          v-model="form.tipo"
                          name="tipo"
                          :class="errors.length > 0 ? 'is-invalid' : null"
                          :placeholder="$t('projectUpsertForm.project.tipoPlaceholder')"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row class="p-2">
                  <b-col sm="6" md="6" lg="6">
                    <b-form-group :label="$t('projectUpsertForm.project.grupo')">
                      <validation-provider
                        #default="{ errors }"
                        :name="$t('projectUpsertForm.project.grupo')"
                        vid="grupo"
                        rules="required"
                      >
                        <b-form-input
                          v-model="form.grupo"
                          name="grupo"
                          :class="errors.length > 0 ? 'is-invalid' : null"
                          :placeholder="$t('projectUpsertForm.project.grupoPlaceholder')"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col sm="6" md="6" lg="6">
                    <b-form-group :label="$t('projectUpsertForm.project.detalhes')">
                      <validation-provider
                        #default="{ errors }"
                        :name="$t('projectUpsertForm.project.detalhes')"
                        vid="detalhes"
                        rules="required"
                      >
                        <b-form-input
                          v-model="form.detalhes"
                          name="detalhes"
                          rows="3"
                          max-rows="3"
                          :class="errors.length > 0 ? 'is-invalid' : null"
                          :placeholder="$t('projectUpsertForm.project.detalhesPlaceholder')"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-tab>

              <b-tab
                button-id="installation"
              >
                <div slot="title">
                  <feather-icon
                    class="mr-1"
                    icon="MapIcon"
                  /> {{ $t('projectUpsertForm.installation.title') }}
                </div>
                <b-row class="p-2">
                  <b-col
                    sm="6"
                    md="6"
                    lg="6"
                  >
                    <b-form-group
                      :label="$t('projectUpsertForm.installation.name')"
                    >
                      <validation-provider
                        #default="{ errors }"
                        :name="$t('projectUpsertForm.installation.name')"
                        vid="Installation.name"
                        rules="required"
                      >
                        <b-form-input
                          v-model="form.Installation.name"
                          name="Installation.name"
                          :class="errors.length > 0 ? 'is-invalid':null"
                          :placeholder="$t('projectUpsertForm.installation.namePlaceholder')"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col
                    sm="6"
                    md="6"
                    lg="6"
                  >
                    <b-form-group
                      :label="$t('projectUpsertForm.installation.cnpj')"
                    >
                      <validation-provider
                        #default="{ errors }"
                        :name="$t('projectUpsertForm.installation.cnpj')"
                        vid="Installation.cnpj"
                        rules="required"
                      >
                        <b-form-input
                          v-model="form.Installation.cnpj"
                          name="Installation.cnpj"
                          :class="errors.length > 0 ? 'is-invalid':null"
                          :placeholder="$t('projectUpsertForm.installation.cnpjPlaceholder')"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row class="p-2">
                  <b-col
                    sm="6"
                    md="6"
                    lg="6"
                  >
                    <b-form-group
                      :label="$t('projectUpsertForm.installation.cep')"
                    >
                      <validation-provider
                        #default="{ errors }"
                        :name="$t('projectUpsertForm.installation.cep')"
                        vid="Installation.cep"
                        rules="required"
                      >
                        <b-form-input
                          v-model="form.Installation.cep"
                          name="Installation.cep"
                          debounce="1000"
                          :class="errors.length > 0 ? 'is-invalid':null"
                          :placeholder="$t('projectUpsertForm.installation.cepPlaceholder')"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col
                    sm="6"
                    md="6"
                    lg="6"
                  >
                    <b-form-group
                      :label="$t('projectUpsertForm.installation.address')"
                    >
                      <validation-provider
                        #default="{ errors }"
                        :name="$t('projectUpsertForm.installation.address')"
                        vid="Installation.address"
                        rules="required"
                      >
                        <b-form-input
                          v-model="form.Installation.address"
                          name="Installation.address"
                          :class="errors.length > 0 ? 'is-invalid':null"
                          :placeholder="$t('projectUpsertForm.installation.addressPlaceholder')"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row class="p-2">
                  <b-col
                    sm="6"
                    md="6"
                    lg="6"
                  >
                    <b-form-group
                      :label="$t('projectUpsertForm.installation.bairro')"
                    >
                      <validation-provider
                        #default="{ errors }"
                        :name="$t('projectUpsertForm.installation.bairro')"
                        vid="Installation.bairro"
                        rules="required"
                      >
                        <b-form-input
                          v-model="form.Installation.bairro"
                          name="Installation.bairro"
                          debounce="1000"
                          :class="errors.length > 0 ? 'is-invalid':null"
                          :placeholder="$t('projectUpsertForm.installation.bairroPlaceholder')"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col
                    sm="6"
                    md="6"
                    lg="6"
                  >
                    <b-form-group
                      :label="$t('projectUpsertForm.installation.estado')"
                    >
                      <validation-provider
                        #default="{ errors }"
                        :name="$t('projectUpsertForm.installation.estado')"
                        vid="Installation.estado"
                        rules="required"
                      >
                        <b-form-input
                          v-model="form.Installation.estado"
                          name="Installation.estado"
                          :class="errors.length > 0 ? 'is-invalid':null"
                          :placeholder="$t('projectUpsertForm.installation.estadoPlaceholder')"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row class="p-2">
                  <b-col
                    sm="6"
                    md="6"
                    lg="6"
                  >
                    <b-form-group
                      :label="$t('projectUpsertForm.installation.city')"
                    >
                      <validation-provider
                        #default="{ errors }"
                        :name="$t('projectUpsertForm.installation.city')"
                        vid="Installation.city"
                        rules="required"
                      >
                        <b-form-input
                          v-model="form.Installation.city"
                          name="Installation.city"
                          :class="errors.length > 0 ? 'is-invalid':null"
                          :placeholder="$t('projectUpsertForm.installation.cityPlaceholder')"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col
                    sm="6"
                    md="6"
                    lg="6"
                  >
                    <b-form-group
                      :label="$t('projectUpsertForm.installation.matr')"
                    >
                      <validation-provider
                        #default="{ errors }"
                        :name="$t('projectUpsertForm.installation.matr')"
                        vid="Installation.matr"
                        rules="required"
                      >
                        <b-form-input
                          v-model="form.Installation.matr"
                          name="Installation.matr"
                          :class="errors.length > 0 ? 'is-invalid':null"
                          :placeholder="$t('projectUpsertForm.installation.matrPlaceholder')"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-tab>

              <b-tab button-id="rooms">
                <template #title>
                  <feather-icon
                    class="mr-1"
                    icon="ImageIcon"
                  /> LINACS e HDRs
                </template>
                <hr style="width: 100%">

                <div
                  v-for="(room, i) in Rooms"
                  :key="room.id || i"
                  class="pb-1 px-2 mb-4"
                  style="margin-left: 0; margin-right: 0;"
                >
                  <hr v-if="i > 0" style="width: 100%" class="my-4">

                  <h5 class="text-primary font-weight-bold mb-3 px-2">
                    LINAC {{ String(i + 1).padStart(2, '0') }}
                  </h5>

                  <b-row>
                    <b-col cols="6" class="px-2">
                      <b-form-group label="Fabricante">
                        <validation-provider
                          #default="{ errors }"
                          class="flex-description-row"
                          :name="$t('projectUpsertForm.rooms.fabric') || 'Fabric'"
                        >
                          <b-form-input
                            v-model="room.fabric"
                            :class="errors.length > 0 ? 'is-invalid' : null"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>

                    <b-col cols="6" class="px-2">
                      <b-form-group label="Modelo">
                        <validation-provider
                          #default="{ errors }"
                          class="flex-description-row"
                          :name="$t('projectUpsertForm.rooms.modelo') || 'Modelo'"
                        >
                          <b-form-input
                            v-model="room.modelo"
                            :class="errors.length > 0 ? 'is-invalid' : null"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col cols="4" class="px-2">
                      <b-form-group label="E(max)">
                        <validation-provider
                          #default="{ errors }"
                          class="flex-description-row"
                          :name="$t('projectUpsertForm.rooms.emax') || 'E(max)'"
                        >
                          <b-form-input
                            v-model="room.emax"
                            :class="errors.length > 0 ? 'is-invalid' : null"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>

                    <b-col cols="4" class="px-2">
                      <b-form-group label="E(gamma)">
                        <validation-provider
                          #default="{ errors }"
                          class="flex-description-row"
                          :name="$t('projectUpsertForm.rooms.egamma') || 'E(gamma)'"
                        >
                          <b-form-input
                            v-model="room.egamma"
                            :class="errors.length > 0 ? 'is-invalid' : null"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>

                    <b-col cols="4" class="px-2">
                      <b-form-group label="E(elet.)">
                        <validation-provider
                          #default="{ errors }"
                          class="flex-description-row"
                          :name="$t('projectUpsertForm.rooms.eelet') || 'E(elet.)'"
                        >
                          <b-form-input
                            v-model="room.eelet"
                            disabled
                            :class="errors.length > 0 ? 'is-invalid' : null"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <div class="d-flex justify-content-end px-2 mt-2">
                    <feather-icon
                      class="text-danger cursor-pointer"
                      icon="Trash2Icon"
                      size="24"
                      @click="deleteRoom(idx)"
                    />
                  </div>
                </div>

                <div
                  v-for="(room, i) in HDR"
                  :key="room.id || i"
                  class="pb-1 px-2 mb-4"
                  style="margin-left: 0; margin-right: 0;"
                >
                  <hr v-if="i > 0" style="width: 100%" class="my-4">

                  <h5 class="text-primary font-weight-bold mb-3 px-2">
                    HDR {{ String(i + 1).padStart(2, '0') }}
                  </h5>

                  <b-row>
                    <b-col cols="6" class="px-2">
                      <b-form-group label="Fabricante">
                        <validation-provider
                          #default="{ errors }"
                          class="flex-description-row"
                          :name="$t('projectUpsertForm.rooms.fabric') || 'Fabric'"
                        >
                          <b-form-input
                            v-model="room.fabric"
                            :class="errors.length > 0 ? 'is-invalid' : null"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>

                    <b-col cols="6" class="px-2">
                      <b-form-group label="Modelo">
                        <validation-provider
                          #default="{ errors }"
                          class="flex-description-row"
                          :name="$t('projectUpsertForm.rooms.modelo') || 'Modelo'"
                        >
                          <b-form-input
                            v-model="room.modelo"
                            :class="errors.length > 0 ? 'is-invalid' : null"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col cols="4" class="px-2">
                      <b-form-group label="Atividade">
                        <validation-provider
                          #default="{ errors }"
                          class="flex-description-row"
                          :name="$t('projectUpsertForm.rooms.atividade') || 'Atividade'"
                        >
                          <b-form-input
                            v-model="room.atividade"
                            :class="errors.length > 0 ? 'is-invalid' : null"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>

                    <b-col cols="4" class="px-2">
                      <b-form-group label="kerma">
                        <validation-provider
                          #default="{ errors }"
                          class="flex-description-row"
                          :name="$t('projectUpsertForm.rooms.kerma') || 'kerma'"
                        >
                          <b-form-input
                            v-model="room.kerma"
                            :class="errors.length > 0 ? 'is-invalid' : null"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>

                    <b-col cols="4" class="px-2">
                      <b-form-group label="fatConv">
                        <validation-provider
                          #default="{ errors }"
                          class="flex-description-row"
                          :name="$t('projectUpsertForm.rooms.fatConv') || 'fatConv'"
                        >
                          <b-form-input
                            v-model="room.fatConv"
                            disabled
                            :class="errors.length > 0 ? 'is-invalid' : null"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <div class="d-flex justify-content-end px-2 mt-2">
                    <feather-icon
                      class="text-danger cursor-pointer"
                      icon="Trash2Icon"
                      size="24"
                      @click="deleteRoomHDR(idx)"
                    />
                  </div>
                </div>

                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  class="ml-2 mb-2 mt-1"
                  :disabled="saving"
                  @click="addProjectRoom()"
                >
                  Adicionar LINAC
                </b-button>
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  class="ml-2 mb-2 mt-1"
                  :disabled="saving"
                  @click="addProjectRoomHDR()"
                >
                  Adicionar HDR
                </b-button>
              </b-tab>
              <b-tab title="Configuração">
                <div v-if="Rooms && Rooms.length">
                  <div v-for="(room, idx) in Rooms" :key="room.id || idx" class="mb-4 p-2 border rounded">
                    <h5>LINAC {{ idx + 1 }}</h5>
                    <b-row>
                      <b-col md="3"><b-form-group label="Pac/dia"><b-form-input v-model="room.pac_dia" :value="room.pac_dia || 100" /></b-form-group></b-col>
                      <b-col md="3"><b-form-group label="Cp/pac"><b-form-input v-model="room.cp_pac" :value="room.cp_pac || 4" /></b-form-group></b-col>
                      <b-col md="3"><b-form-group label="Dose"><b-form-input v-model="room.dose" :value="room.dose || 0.58" /></b-form-group></b-col>
                      <b-col md="3"><b-form-group label="Wfis"><b-form-input v-model="room.wfis" :value="room.wfis || 41" /></b-form-group></b-col>
                    </b-row>
                    <b-row>
                      <b-col md="3"><b-form-group label="Beam stop"><b-form-input v-model="room.beam_stop" :value="room.beam_stop || 1" /></b-form-group></b-col>
                      <b-col md="3"><b-form-group label="leak"><b-form-input v-model="room.leak" :value="room.leak || 1.0e-3" /></b-form-group></b-col>
                      <b-col md="3"><b-form-group label="piso"><b-form-input v-model="room.piso" :value="room.piso || 1" /></b-form-group></b-col>
                    </b-row>
                    <b-row>
                      <b-col md="3"><b-form-group label="%IMRT"><b-form-input v-model="room.imrt" :value="room.imrt || 100" /></b-form-group></b-col>
                      <b-col md="3"><b-form-group label="C (IMRT)"><b-form-input v-model="room.c_imrt" :value="room.c_imrt || 2.5" /></b-form-group></b-col>
                      <b-col md="3"><b-form-group label="%VMAT"><b-form-input v-model="room.vmat" :value="room.vmat || 0" /></b-form-group></b-col>
                      <b-col md="3"><b-form-group label="C (VMAT)"><b-form-input v-model="room.c_vmat" :value="room.c_vmat || 2.5" /></b-form-group></b-col>
                    </b-row>
                    <b-row>
                      <b-col md="3"><b-form-group label="%TBI"><b-form-input v-model="room.tbi" :value="room.tbi || 0" /></b-form-group></b-col>
                      <b-col md="3"><b-form-group label="npac TBI"><b-form-input v-model="room.npac_tbi" :value="room.npac_tbi || 1" /></b-form-group></b-col>
                      <b-col md="3"><b-form-group label="dose_tbi"><b-form-input v-model="room.dose_tbi" :value="room.dose_tbi || 12" /></b-form-group></b-col>
                      <b-col md="3"><b-form-group label="dx_tbi"><b-form-input v-model="room.dx_tbi" :value="room.dx_tbi || 4.0" /></b-form-group></b-col>
                    </b-row>
                    <b-row>
                      <b-col md="3"><b-form-group label="npts(pri)"><b-form-input v-model="room.npts_pri" :value="room.npts_pri || 5" /></b-form-group></b-col>
                      <b-col md="3"><b-form-group label="npts(sec)"><b-form-input v-model="room.npts_sec" :value="room.npts_sec || 10" /></b-form-group></b-col>
                    </b-row>
                    <b-row>
                      <b-col md="3"><b-form-group label="pdir(sl)"><b-form-input v-model="room.pdir_sl" :value="room.pdir_sl || 4.0" /></b-form-group></b-col>
                      <b-col md="3"><b-form-group label="pdir(lb)"><b-form-input v-model="room.pdir_lb" :value="room.pdir_lb || 4.0" /></b-form-group></b-col>
                      <b-col md="3"><b-form-group label="cmax"><b-form-input v-model="room.cmax" :value="room.cmax || 0.28" /></b-form-group></b-col>
                      <b-col md="3"><b-form-group label="ceq"><b-form-input v-model="room.ceq" :value="room.ceq || 0.28" /></b-form-group></b-col>
                    </b-row>
                    <b-row>
                      <b-col md="6"><b-form-group label="causa"><b-form-input v-model="room.causa" :value="room.causa || 'O campo máximo é limitado a 28 cm na diagonal.'" /></b-form-group></b-col>
                    </b-row>
                    <b-row>
                      <b-col md="2"><b-form-group label="$concreto"><b-form-input v-model="room.concreto" :value="room.concreto || 650.0" /></b-form-group></b-col>
                      <b-col md="2"><b-form-group label="$chumbo"><b-form-input v-model="room.chumbo" :value="room.chumbo || 10.0" /></b-form-group></b-col>
                      <b-col md="2"><b-form-group label="$BPE"><b-form-input v-model="room.bpe" :value="room.bpe || 30.0" /></b-form-group></b-col>
                      <b-col md="2"><b-form-group label="F(cm2)"><b-form-input v-model="room.f_cm2" :value="room.f_cm2 || 1600.0" /></b-form-group></b-col>
                      <b-col md="2"><b-form-group label="alpha"><b-form-input v-model="room.alpha" :value="room.alpha || 10000.0" /></b-form-group></b-col>
                      <b-col md="2"><b-form-group label="TV"><b-form-input v-model="room.tv" :value="room.tv || 1000.0" /></b-form-group></b-col>
                    </b-row>
                    <b-row>
                      <b-col md="3"><b-form-group label="densidade"><b-form-input v-model="room.densidade" :value="room.densidade || 2.35" /></b-form-group></b-col>
                    </b-row>
                  </div>
                </div>
                <div v-else class="text-muted justify-content-center ml-3"><p>Nenhum LINAC cadastrado.</p></div>
                <div v-if="HDR && HDR.length">
                  <div v-for="(room, idx) in HDR" :key="room.id || idx" class="mb-4 p-2 border rounded">
                    <h5>HDR {{ idx + 1 }}</h5>
                    <b-row>
                      <b-col md="3"><b-form-group label="Pac/semana"><b-form-input v-model="room.pacSem" :value="room.pacSem" /></b-form-group></b-col>
                      <b-col md="3"><b-form-group label="insercoes"><b-form-input v-model="room.insercoes" :value="room.insercoes" /></b-form-group></b-col>
                      <b-col md="3"><b-form-group label="tempo insercao"><b-form-input v-model="room.tempoIns" :value="room.tempoIns" /></b-form-group></b-col>
                      <b-col md="3"><b-form-group label="Wfis"><b-form-input v-model="room.wfis" :value="room.wfis" /></b-form-group></b-col>
                    </b-row>
                    <b-row>
                      <b-col md="3"><b-form-group label="npts"><b-form-input v-model="room.npts" :value="room.npts" /></b-form-group></b-col>
                      <b-col md="3"><b-form-group label="pdirsl"><b-form-input v-model="room.pdirsl" :value="room.pdirsl" /></b-form-group></b-col>
                      <b-col md="3"><b-form-group label="pdirlb"><b-form-input v-model="room.pdirlb" :value="room.pdirlb" /></b-form-group></b-col>
                      <b-col md="3"><b-form-group label="concreto"><b-form-input v-model="room.concreto" :value="room.concreto" /></b-form-group></b-col>
                    </b-row>
                    <b-row>
                      <b-col md="3"><b-form-group label="chumbo"><b-form-input v-model="room.chumbo" :value="room.chumbo" /></b-form-group></b-col>
                      <b-col md="3"><b-form-group label="alpha"><b-form-input v-model="room.alpha" :value="room.alpha" /></b-form-group></b-col>
                      <b-col md="3"><b-form-group label="TV"><b-form-input v-model="room.TV" :value="room.TV" /></b-form-group></b-col>
                      <b-col md="3"><b-form-group label="densidade"><b-form-input v-model="room.densidade" :value="room.densidade" /></b-form-group></b-col>
                    </b-row>
                  </div>
                </div>
                <div v-else class="text-muted justify-content-center ml-3"><p>Nenhum HDR cadastrado.</p></div>
              </b-tab>
              <b-tab title="Barreiras PRIM por Sala/Linac">
                <div v-for="(room, rIndex) in Rooms" :key="room.id || rIndex" class="mb-4">
                  <h5 class="ml-3 mb-2">{{ room.name || ('Linac ' + (rIndex + 1)) }}</h5>

                  <!-- existing barriers repeater -->
                  <div v-for="(barrier, bIndex) in roomsBarriers[rIndex]" :key="bIndex" >
                    <div class="border rounded p-3 mb-2" v-if="barrier.barrierType === 'prim'">
                      <div class="d-flex justify-content-between align-items-center mb-2">
                        <strong>Barreira {{ bIndex + 1 }}</strong>
                        <b-button size="sm" variant="danger" @click="removeBarrier(rIndex, bIndex)">Remover</b-button>
                      </div>

                      <b-form-row>
                        <b-col cols="4">
                          <b-form-group label="Tipo de Barreira">
                            <b-form-select v-model="barrier.barrierType" :options="barrierTypeOptions" @change="onBarrierTypeChange(rIndex, bIndex)" disabled></b-form-select>
                          </b-form-group>
                        </b-col>

                        <b-col cols="8">
                          <b-form-group label="Name">
                            <b-form-input v-model="barrier.name"></b-form-input>
                          </b-form-group>
                        </b-col>
                      </b-form-row>

                      <!-- FIELDS FOR PRIMARY (prim) -->
                      <div v-if="barrier.barrierType === 'prim'">
                        <b-form-row>
                          <b-col md="4"><b-form-group label="Área"><b-form-input v-model="barrier.area"></b-form-input></b-form-group></b-col>
                          <b-col md="4"><b-form-group label="limite"><b-form-input v-model="barrier.limite"></b-form-input></b-form-group></b-col>
                          <b-col md="4"><b-form-group label="Nr fontes"><b-form-input v-model.number="barrier.nr_fontes"></b-form-input></b-form-group></b-col>
                        </b-form-row>

                        <b-form-row>
                          <b-col md="3"><b-form-group label="TBI"><b-form-input v-model.number="barrier.TBI"></b-form-input></b-form-group></b-col>
                          <b-col md="3"><b-form-group label="dpri"><b-form-input v-model.number="barrier.dpri"></b-form-input></b-form-group></b-col>
                          <b-col md="3"><b-form-group label="unum"><b-form-input v-model.number="barrier.unum"></b-form-input></b-form-group></b-col>
                          <b-col md="3"><b-form-group label="uden"><b-form-input v-model.number="barrier.uden"></b-form-input></b-form-group></b-col>
                        </b-form-row>

                        <b-form-row>
                          <b-col md="3"><b-form-group label="tden"><b-form-input v-model.number="barrier.tden"></b-form-input></b-form-group></b-col>
                          <b-col md="3"><b-form-group label="dcint"><b-form-input v-model.number="barrier.dcint"></b-form-input></b-form-group></b-col>
                          <b-col md="3"><b-form-group label="compr"><b-form-input v-model.number="barrier.compr"></b-form-input></b-form-group></b-col>
                          <b-col md="3"><b-form-group label="lfim"><b-form-input v-model.number="barrier.lfim"></b-form-input></b-form-group></b-col>
                        </b-form-row>

                        <b-form-row>
                          <b-col md="3"><b-form-group label="notim"><b-form-input v-model.number="barrier.notim"></b-form-input></b-form-group></b-col>
                          <b-col md="3"><b-form-group label="efim"><b-form-input v-model.number="barrier.efim"></b-form-input></b-form-group></b-col>
                          <b-col md="3"><b-form-group label="eplanta"><b-form-input v-model.number="barrier.eplanta"></b-form-input></b-form-group></b-col>
                          <b-col md="3"><b-form-group label="lplanta"><b-form-input v-model.number="barrier.lplanta"></b-form-input></b-form-group></b-col>
                        </b-form-row>

                        <b-form-row>
                          <b-col md="3"><b-form-group label="rho(mat.)"><b-form-input v-model.number="barrier.rho"></b-form-input></b-form-group></b-col>
                          <b-col md="3"><b-form-group label="esp(mat.)"><b-form-input v-model.number="barrier.esp"></b-form-input></b-form-group></b-col>
                          <b-col md="6"><b-form-group label="Observações"><b-form-textarea rows="2" v-model="barrier.obs"></b-form-textarea></b-form-group></b-col>
                        </b-form-row>
                      </div>

                    </div>
                  </div>

                  <b-button class="ml-3" size="sm" variant="primary" @click="addBarrier(rIndex, 'prim')">Adicionar barreira primária</b-button>

                </div>
                <hr />
              </b-tab>
              <b-tab title="Barreiras SEC por Sala/Linac">
                <div v-for="(room, rIndex) in Rooms" :key="room.id || rIndex" class="mb-4">
                  <h5 class="ml-3 mb-2">{{ room.name || ('Linac ' + (rIndex + 1)) }}</h5>

                  <!-- existing barriers repeater -->
                  <div v-for="(barrier, bIndex) in roomsBarriers[rIndex]" :key="bIndex">
                    <div class="border rounded p-3 mb-2" v-if="barrier.barrierType === 'sec'">

                      <!-- FIELDS FOR SECONDARY (sec) -->
                      <div v-if="barrier.barrierType === 'sec'">
                        <div class="d-flex justify-content-between align-items-center mb-2">
                        <strong>Barreira {{ bIndex + 1 }}</strong>
                        <b-button size="sm" variant="danger" @click="removeBarrier(rIndex, bIndex)">Remover</b-button>
                      </div>

                      <b-form-row>
                        <b-col cols="4">
                          <b-form-group label="Tipo de Barreira">
                            <b-form-select v-model="barrier.barrierType" :options="barrierTypeOptions" @change="onBarrierTypeChange(rIndex, bIndex)" disabled></b-form-select>
                          </b-form-group>
                        </b-col>

                        <b-col cols="8">
                          <b-form-group label="Name">
                            <b-form-input v-model="barrier.name"></b-form-input>
                          </b-form-group>
                        </b-col>
                      </b-form-row>
                        <b-form-row>
                          <b-col md="4"><b-form-group label="Área"><b-form-input v-model="barrier.area"></b-form-input></b-form-group></b-col>
                          <b-col md="4"><b-form-group label="limite"><b-form-input v-model="barrier.limite"></b-form-input></b-form-group></b-col>
                          <b-col md="4"><b-form-group label="Nr fontes"><b-form-input v-model.number="barrier.nr_fontes"></b-form-input></b-form-group></b-col>
                        </b-form-row>

                        <b-form-row>
                          <b-col md="3"><b-form-group label="dsec"><b-form-input v-model.number="barrier.dsec"></b-form-input></b-form-group></b-col>
                          <b-col md="3"><b-form-group label="tden"><b-form-input v-model.number="barrier.tden"></b-form-input></b-form-group></b-col>
                          <b-col md="3"><b-form-group label="theta"><b-form-input v-model.number="barrier.theta"></b-form-input></b-form-group></b-col>
                          <b-col md="3"><b-form-group label="notim"><b-form-input v-model.number="barrier.notim"></b-form-input></b-form-group></b-col>
                        </b-form-row>

                        <b-form-row>
                          <b-col md="4"><b-form-group label="largura"><b-form-input v-model.number="barrier.largura"></b-form-input></b-form-group></b-col>
                          <b-col md="4"><b-form-group label="compr"><b-form-input v-model.number="barrier.compr"></b-form-input></b-form-group></b-col>
                          <b-col md="4"><b-form-group label="efim"><b-form-input v-model.number="barrier.efim"></b-form-input></b-form-group></b-col>
                        </b-form-row>

                        <b-form-row>
                          <b-col md="3"><b-form-group label="planta"><b-form-input v-model.number="barrier.planta"></b-form-input></b-form-group></b-col>
                          <b-col md="3"><b-form-group label="rho(mat.)"><b-form-input v-model.number="barrier.rho"></b-form-input></b-form-group></b-col>
                          <b-col md="3"><b-form-group label="esp(mat.)"><b-form-input v-model.number="barrier.esp"></b-form-input></b-form-group></b-col>
                          <b-col md="6"><b-form-group label="Observações"><b-form-textarea rows="2" v-model="barrier.obs"></b-form-textarea></b-form-group></b-col>
                        </b-form-row>
                      </div>

                    </div>
                  </div>
                  <b-button class="ml-3" size="sm" variant="primary" @click="addBarrier(rIndex, 'sec')">Adicionar barreira secundária</b-button>
                  <!-- required LABIRINTO -->
                  <div class="border rounded p-3 mt-3">
                    <div class="d-flex justify-content-between align-items-center mb-2">
                      <strong>LABIRINTO (obrigatório)</strong>
                    </div>
                    <b-row>
                      <b-col md="4">
                        <b-form-group label="L">
                          <b-form-input :placeholder="'L'" v-model="room.labirinto.L"></b-form-input>
                        </b-form-group>
                      </b-col>
                      <b-col md="4">
                        <b-form-group label="esp(lab)">
                          <b-form-input v-model="room.labirinto.esp_lab"></b-form-input>
                        </b-form-group>
                      </b-col>
                      <b-col md="4">
                        <b-form-group label="planta">
                          <b-form-input v-model="room.labirinto.planta"></b-form-input>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </div>

                  <!-- required PORTA -->
                  <div class="border rounded p-3 mt-3">
                    <div class="d-flex justify-content-between align-items-center mb-2">
                      <strong>PORTA (obrigatório)</strong>
                    </div>

                    <b-row>
                      <b-col md="4"><b-form-group label="Área"><b-form-input v-model="room.porta.area"></b-form-input></b-form-group></b-col>
                      <b-col md="4"><b-form-group label="limite"><b-form-input v-model="room.porta.limite"></b-form-input></b-form-group></b-col>
                      <b-col md="4"><b-form-group label="Nr fontes"><b-form-input v-model="room.porta.nr_fontes"></b-form-input></b-form-group></b-col>
                    </b-row>

                    <b-row>
                      <b-col md="3"><b-form-group label="tden"><b-form-input v-model="room.porta.tden"></b-form-input></b-form-group></b-col>
                      <b-col md="3"><b-form-group label="dp"><b-form-input v-model="room.porta.dp"></b-form-input></b-form-group></b-col>
                      <b-col md="3"><b-form-group label="dr"><b-form-input v-model="room.porta.dr"></b-form-input></b-form-group></b-col>
                      <b-col md="3"><b-form-group label="dz"><b-form-input v-model="room.porta.dz"></b-form-input></b-form-group></b-col>
                    </b-row>

                    <b-row>
                      <b-col md="3"><b-form-group label="ds"><b-form-input v-model="room.porta.ds"></b-form-input></b-form-group></b-col>
                      <b-col md="3"><b-form-group label="L0"><b-form-input v-model="room.porta.L0"></b-form-input></b-form-group></b-col>
                      <b-col md="3"><b-form-group label="L1"><b-form-input v-model="room.porta.L1"></b-form-input></b-form-group></b-col>
                      <b-col md="3"><b-form-group label="Ls"><b-form-input v-model="room.porta.Ls"></b-form-input></b-form-group></b-col>
                    </b-row>

                    <b-row>
                      <b-col md="3"><b-form-group label="theta(0)"><b-form-input v-model="room.porta.theta0"></b-form-input></b-form-group></b-col>
                      <b-col md="3"><b-form-group label="theta(z)"><b-form-input v-model="room.porta.thetaz"></b-form-input></b-form-group></b-col>
                      <b-col md="3"><b-form-group label="theta(s)"><b-form-input v-model="room.porta.thetas"></b-form-input></b-form-group></b-col>
                    </b-row>
                    <b-row>
                      <b-col md="3"><b-form-group label="dsec"><b-form-input v-model="room.porta.dsec1"></b-form-input></b-form-group></b-col>
                      <b-col md="3"><b-form-group label="dzz"><b-form-input v-model="room.porta.dzz1"></b-form-input></b-form-group></b-col>
                      <b-col md="3"><b-form-group label="L1"><b-form-input v-model="room.porta.L1_1"></b-form-input></b-form-group></b-col>
                      <b-col md="3"><b-form-group label="theta1"><b-form-input v-model="room.porta.theta1_1"></b-form-input></b-form-group></b-col>
                    </b-row>
                    <b-row>
                      <b-col md="3"><b-form-group label="dsec2"><b-form-input v-model="room.porta.dsec2"></b-form-input></b-form-group></b-col>
                      <b-col md="3"><b-form-group label="dzz2"><b-form-input v-model="room.porta.dzz2"></b-form-input></b-form-group></b-col>
                      <b-col md="3"><b-form-group label="L1_2"><b-form-input v-model="room.porta.L1_2"></b-form-input></b-form-group></b-col>
                      <b-col md="3"><b-form-group label="theta1_2"><b-form-input v-model="room.porta.theta1_2"></b-form-input></b-form-group></b-col>
                    </b-row>
                    <b-row>
                      <b-col md="3"><b-form-group label="dlab"><b-form-input v-model="room.porta.dlab"></b-form-input></b-form-group></b-col>
                      <b-col md="3"><b-form-group label="d1"><b-form-input v-model="room.porta.d1"></b-form-input></b-form-group></b-col>
                      <b-col md="3"><b-form-group label="d2"><b-form-input v-model="room.porta.d2"></b-form-input></b-form-group></b-col>
                    </b-row>

                    <b-row>
                      <b-col md="3"><b-form-group label="s0"><b-form-input v-model="room.porta.s0"></b-form-input></b-form-group></b-col>
                      <b-col md="3"><b-form-group label="s1"><b-form-input v-model="room.porta.s1"></b-form-input></b-form-group></b-col>
                      <b-col md="3"><b-form-group label="sr"><b-form-input v-model="room.porta.sr"></b-form-input></b-form-group></b-col>
                      <b-col md="3"><b-form-group label="npor"><b-form-input v-model="room.porta.npor"></b-form-input></b-form-group></b-col>
                    </b-row>

                    <b-row>
                      <b-col md="3"><b-form-group label="altpor"><b-form-input v-model="room.porta.altpor"></b-form-input></b-form-group></b-col>
                      <b-col md="3"><b-form-group label="larpor"><b-form-input v-model="room.porta.larpor"></b-form-input></b-form-group></b-col>
                      <b-col md="3"><b-form-group label="prop(pb)"><b-form-input v-model="room.porta.prop_pb"></b-form-input></b-form-group></b-col>
                      <b-col md="3"><b-form-group label="prop(hbe)"><b-form-input v-model="room.porta.prop_hbe"></b-form-input></b-form-group></b-col>
                    </b-row>
                  </div>
                </div>
                <hr />
              </b-tab>
              <b-tab title="Barreiras por Sala/HDR">
                <div v-for="(room, rIndex) in HDR" :key="room.id || rIndex" class="mb-4">
                  <h5 class="ml-3 mb-2">{{ room.name || ('HDR ' + (rIndex + 1)) }}</h5>

                  <!-- existing barriers repeater -->
                  <div v-for="(barrier, bIndex) in hdrBarriers[rIndex]" :key="bIndex" class="border rounded p-3 mb-2">
                    <div class="d-flex justify-content-between align-items-center mb-2">
                      <strong>Barreira {{ bIndex + 1 }}</strong>
                      <b-button size="sm" variant="danger" @click="removeBarrierHDR(rIndex, bIndex)">Remover</b-button>
                    </div>

                    <b-form-row>
                      <b-col cols="4">
                        <b-form-group label="Tipo de Barreira">
                          <b-form-select v-model="barrier.barrierType" :options="barrierTypeOptionsHDR"></b-form-select>
                        </b-form-group>
                      </b-col>

                      <b-col cols="8">
                        <b-form-group label="Name">
                          <b-form-input v-model="barrier.I"></b-form-input>
                        </b-form-group>
                      </b-col>
                    </b-form-row>

                    <!-- FIELDS FOR PRIMARY (prim) -->
                    <div>
                      <b-form-row>
                        <b-col md="4"><b-form-group label="limite"><b-form-input v-model="barrier.limite"></b-form-input></b-form-group></b-col>
                        <b-col md="4"><b-form-group label="dsec"><b-form-input v-model="barrier.dsec"></b-form-input></b-form-group></b-col>
                      </b-form-row>

                      <b-form-row>
                        <b-col md="3"><b-form-group label="tden"><b-form-input v-model.number="barrier.tden"></b-form-input></b-form-group></b-col>
                      </b-form-row>

                      <b-form-row>
                        <b-col md="3"><b-form-group label="notim"><b-form-input v-model.number="barrier.notim"></b-form-input></b-form-group></b-col>
                        <b-col md="3"><b-form-group label="largura"><b-form-input v-model.number="barrier.largura"></b-form-input></b-form-group></b-col>
                        <b-col md="3"><b-form-group label="compr"><b-form-input v-model.number="barrier.compr"></b-form-input></b-form-group></b-col>
                        <b-col md="3"><b-form-group label="efim"><b-form-input v-model.number="barrier.efim"></b-form-input></b-form-group></b-col>
                      </b-form-row>

                      <b-form-row>
                        <b-col md="3"><b-form-group label="planta"><b-form-input v-model.number="barrier.planta"></b-form-input></b-form-group></b-col>
                        <b-col md="6"><b-form-group label="Observações"><b-form-textarea rows="2" v-model="barrier.obs"></b-form-textarea></b-form-group></b-col>
                      </b-form-row>
                    </div>
                  </div>

                  <b-button class="ml-3" size="sm" variant="primary" @click="addBarrierHDR(rIndex)">Adicionar barreira secundária</b-button>
                  <!-- required LABIRINTO -->
                  <div class="border rounded p-3 mt-3">
                    <div class="d-flex justify-content-between align-items-center mb-2">
                      <strong>LABIRINTO (obrigatório)</strong>
                    </div>
                    <b-row>
                      <b-col md="4">
                        <b-form-group label="L">
                          <b-form-input :placeholder="'L'" v-model="room.labirinto.L"></b-form-input>
                        </b-form-group>
                      </b-col>
                      <b-col md="4">
                        <b-form-group label="esp(lab)">
                          <b-form-input v-model="room.labirinto.esp_lab"></b-form-input>
                        </b-form-group>
                      </b-col>
                      <b-col md="4">
                        <b-form-group label="planta">
                          <b-form-input v-model="room.labirinto.planta"></b-form-input>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </div>

                  <!-- required PORTA -->
                  <div class="border rounded p-3 mt-3">
                    <div class="d-flex justify-content-between align-items-center mb-2">
                      <strong>PORTA (obrigatório)</strong>
                    </div>

                    <b-row>
                      <b-col md="4"><b-form-group label="limite"><b-form-input v-model="room.porta.limite"></b-form-input></b-form-group></b-col>
                    </b-row>
                    <b-row>
                      <b-col md="3"><b-form-group label="df"><b-form-input v-model="room.porta.df"></b-form-input></b-form-group></b-col>
                      <b-col md="3"><b-form-group label="dp"><b-form-input v-model="room.porta.dp"></b-form-input></b-form-group></b-col>
                      <b-col md="3"><b-form-group label="dr"><b-form-input v-model="room.porta.dr"></b-form-input></b-form-group></b-col>
                      <b-col md="3"><b-form-group label="L0"><b-form-input v-model="room.porta.L0"></b-form-input></b-form-group></b-col>
                    </b-row>
                    <b-row>
                      <b-col md="3"><b-form-group label="elab"><b-form-input v-model="room.porta.elab"></b-form-input></b-form-group></b-col>
                      <b-col md="3"><b-form-group label="altpor"><b-form-input v-model="room.porta.altpor"></b-form-input></b-form-group></b-col>
                      <b-col md="3"><b-form-group label="larpor"><b-form-input v-model="room.porta.larpor"></b-form-input></b-form-group></b-col>
                      <b-col md="3"><b-form-group label="proppb"><b-form-input v-model="room.porta.proppb"></b-form-input></b-form-group></b-col>
                    </b-row>
                  </div>
                </div>
                <hr />
              </b-tab>
            </b-tabs>

            <div
              slot="footer"
              style="display: flex; justify-content: space-between;"
            >
              <div>
                <b-button
                  id="save-form"
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  variant="primary"
                  class="mr-1"
                  :disabled="!hasValidArrays || invalid || saving"
                >
                  <b-spinner
                    v-if="saving"
                    small
                  />
                  {{ saving ? $t('projectUpsertForm.saving') : $t('projectUpsertForm.save') }}
                </b-button>

                <b-button
                  v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                  variant="outline-secondary"
                  type="reset"
                  :disabled="saving"
                  @click.prevent="goToList"
                >
                  {{ $t('projectUpsertForm.cancel') }}
                </b-button>
              </div>
            </div>
          </b-card>
        </form>
      </validation-observer>
    </b-overlay>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import {
  BTabs, BTab, BCard, BFormGroup, BFormInput, BRow,
  BCol, BButton, BSpinner, BOverlay, BAlert, BFormSelect, BFormTextarea, BFormRow,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ImageInput from '@/views/components/ImageInput.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

// We need this to make vue rendering smoother for non-saved data
function removeTempIdFromObject(obj) {
  const cloned = { ...obj }

  if (obj.id && typeof obj.id === 'string' && obj.id.startsWith('tmpid-')) {
    delete cloned.id
  }

  return cloned
}

export default {
  name: 'ProjectUpsertForm',

  components: {
    BTabs,
    BTab,
    BCard,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BButton,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
    BOverlay,
    BAlert,
    BFormSelect,
    BFormTextarea,
    BFormRow,
    ImageInput,
  },
  directives: { Ripple },

  data() {
    return {
      barriers: [],
      calcParams: [],
      // Alert
      dismissSecs: 4,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      alertData: {
        lightText: null,
        strongText: null,
        variant: 'danger',
      },

      tabIndex: 0,
      saving: false,
      form: {
        hsiev: 10000,
        tvida: 1000,
        pictureUrl: '',
        autor: 'Helio Salmon Jr.',
        supervisor: 'Laís Maria da Silva Henriques (RT-0434)',
        technician: 'Lucas Marques Mendonça (CB-8213)',
        titular: 'Sidney Batista Neves',
        cpfTitular: '526.080.006-06',
        proposito: 'Solicitação da Autorização para Construção de sala.',
        tipo: 'Construção',
        detalhes: 'A sala é proposta para abrigar um acelerador linear de elétrons Varian, modelo Halcyon, de 6 MV de energia máxima, sem enegias de elétrons, e com 100 de carga de trabalho em IMRT. A sala é nova e existem outros equipamentos emissores de radiação nos arredores da sala, portanto os limites de dose serão adaptados a consideração mais de uma contribuições de fontes na região protegida.',
        grupo: '7C',
        Installation: {
          name: 'Hospital do Câncer de Pernambuco',
          address: ' Av. Cruz Cabugá, 1597, ',
          cep: '50040-000',
          city: 'Recife',
          cnpj: '10.894.988/0001-33',
          matr: '11552',
          bairro: 'Santo Amaro',
          estado: 'PE',
        },
      },
      Rooms: [],
      HDR: [],
      hdrBarriers: [],
      roomsBarriers: [],
      labirinto: {},
      porta: {},
      required,
    }
  },
  computed: {
    hasValidArrays() { return this.Rooms.length },
    barrierTypeOptions() {
      return [
        { value: 'prim', text: 'Primária' },
        { value: 'sec', text: 'Secundária' },
      ]
    },
    barrierTypeOptionsHDR() {
      return [
        { value: 'prim', text: 'Secundária' },
        // TODO OBS - NO Código fortran de exemplo aparece como primaria mas helio pediu para no texto aparecer como secundária
      ]
    },
  },
  watch: { 'form.Installation.cep': 'getCep' },
  async created() {
    await this.load()
  },
  methods: {
    ...mapActions('project', {
      loadProject: 'getMultiUpsert',
      upsertProject: 'upsert',
    }),
    async getCep(addressCode) {
      if (!addressCode) return
      try {
        const data = await this.$store.dispatch('address/search', { addressCode })
        // console.log(data)
        this.form.Installation.city = data.city
        this.form.Installation.address = `${data.street}`
        this.form.Installation.bairro = `${data.neighborhood}`
        this.form.Installation.estado = `${data.uf}`
      } catch (e) {
        // eslint-disable-next-line
        console.log(e)
      }
    },
    prim() {
      return {
        barrierType: 'prim',
        name: 'Acesso área técnica',
        area: 'Livre',
        limite: '2.0e-5',
        nr_fontes: 1,
        TBI: 0,
        dpri: 5.2,
        unum: 1,
        uden: 7,
        tden: 20,
        dcint: 4.9,
        compr: 0.0,
        lfim: 0.8,
        notim: 0.5,
        efim: 1.1,
        eplanta: 1.1,
        lplanta: 0.8,
        rho: 0.0,
        esp: 0.0,
        obs: '',
      }
    },
    sec() {
      return {
        barrierType: 'sec',
        name: 'Comando Halcyon 02',
        area: 'Livre',
        limite: '2.0e-5',
        nr_fontes: 2,
        dsec: 4.5,
        tden: 1,
        theta: 28.0,
        notim: 2.0,
        largura: 4.2,
        compr: 0.0,
        efim: 1.5,
        planta: 1.0,
        rho: 0.0,
        esp: 0.0,
        obs: 'Há a contribuição de duas fontes na região.',
      }
    },
    addBarrier(roomIndex, type) {
      if (!this.roomsBarriers[roomIndex]) {
        this.$set(this.roomsBarriers, roomIndex, [])
      }
      this.roomsBarriers[roomIndex].push(this[type]())
    },
    onBarrierTypeChange(roomIndex, barrierIndex) {
      const b = this.roomsBarriers[roomIndex][barrierIndex]
      const name = b.name || ''
      this.$set(this.roomsBarriers[roomIndex], barrierIndex, this[b.barrierType](b.barrierType))
      this.roomsBarriers[roomIndex][barrierIndex].name = name || this.roomsBarriers[roomIndex][barrierIndex].name
    },
    removeBarrier(roomIndex, barrierIndex) {
      if (!this.roomsBarriers[roomIndex]) return
      this.roomsBarriers[roomIndex].splice(barrierIndex, 1)
    },
    addBarrierHDR(roomIndex) {
      if (!this.hdrBarriers[roomIndex]) {
        this.$set(this.hdrBarriers, roomIndex, [])
      }
      this.hdrBarriers[roomIndex].push({
        I: 'Sala do acelerador adjacente',
        barrierType: 'prim',
        limite: 2.0e-5,
        dsec: 5.4,
        tden: 2,
        notim: 1.5,
        largura: 5.0,
        compr: 0.0,
        efim: 1.3,
        planta: 1.3,
        obs: '',
      })
    },
    removeBarrierHDR(roomIndex, barrierIndex) {
      if (!this.hdrBarriers[roomIndex]) return
      this.hdrBarriers[roomIndex].splice(barrierIndex, 1)
    },
    onChangePicture(pictureUrl, room, field) {
      // eslint-disable-next-line
      room[field] = pictureUrl
    },
    goToList() { this.$router.push({ name: 'pages-project' }) },
    async load() {
      await Promise.all([this.loadProjectForRoute()])
    },
    showAlert(alertProps, variant) {
      this.alertData = alertProps
      this.alertData.variant = variant
      this.dismissCountDown = this.dismissSecs
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    async loadProjectForRoute() {
      const { id } = this.$route.params
      if (!id || id === 'new') return
      let project = await this.loadProject(id)
      project = JSON.parse(project.input) // deep clone to avoid mutating the store state
      project = { id, ...project.data }
      // console.log(project)
      let count = 0
      // eslint-disable-next-line no-restricted-syntax
      for (const room of project.Rooms) {
        this.addProjectRoom()
        // eslint-disable-next-line no-restricted-syntax
        for (const barrier of room.barriers) {
          // eslint-disable-next-line no-console
          console.log('Adding barrier', barrier)
          this.addBarrier(count, barrier.barrierType)
        }
        count = +1
      }
      count = 0
      // eslint-disable-next-line no-restricted-syntax
      for (const room of project.HDR) {
        this.addProjectRoomHDR()
        // eslint-disable-next-line no-restricted-syntax
        for (const barrier of room.barriers) {
          // eslint-disable-next-line no-console
          console.log('Adding HDR barrier', barrier)
          this.addBarrierHDR(count)
        }
        count = +1
      }
      this.Rooms = project.Rooms
      this.HDR = project.HDR
      const keysToDelete = ['deletedAt', 'createdAt', 'updatedAt']
      keysToDelete.forEach(key => { delete project[key] })
      this.form = project
    },
    deleteRoom(index) { this.Rooms.splice(index, 1) },
    deleteRoomHDR(index) { this.HDR.splice(index, 1) },
    async onSubmit() {
      // validate form
      const success = await this.$refs.form.validate()
      if (!success) return

      // build Rooms array with associated barriers, labirinto and porta
      const roomsToSend = (this.Rooms || []).map((room, idx) => {
        const barriers = (this.roomsBarriers[idx] || []).map(b => ({ ...b }))

        const labirinto = room.labirinto || {
          L: 'Labirinto',
          esp_lab: 1.1,
          planta: 1.1,
        }

        const porta = room.porta || {
          area: 'Livre',
          limite: '2.0e-5',
          nr_fontes: 2,
          tden: 8,
          dp: 4.5,
          dr: 7.9,
          dz: 3.2,
          ds: 0.0,
          L0: 2.2,
          L1: 3.8,
          Ls: 0.0,
          theta0: 32.0,
          thetaz: 31.0,
          thetas: 0.0,

          dsec1: 5.4,
          dzz1: 6.8,
          L1_1: 3.5,
          theta1_1: 46.0,
          dsec2: 5.4,
          dzz2: 6.8,
          L1_2: 3.5,
          theta1_2: 46.0,

          dlab: 5.9,
          d1: 5.7,
          d2: 7.7,
          s0: 3.1,
          s1: 2.15,
          sr: 312.2,
          npor: 0.25,
          altpor: 2.1,
          larpor: 1.5,
          prop_pb: 6.0,
          prop_hbe: 0.0,
        }

        return {
          ...removeTempIdFromObject(room),
          barriers,
          labirinto,
          porta,
        }
      })

      const hdrToSend = (this.HDR || []).map((room, idx) => {
        const barriers = (this.hdrBarriers[idx] || []).map(b => ({ ...b }))
        const labirinto = room.labirinto || {
          L: 'Labirinto de entrada da sala',
          esp_lab: 0.4,
          planta: 0.0,
        }
        const porta = room.porta || {
          limite: '2.0e-5',
          df: 4.2,
          dp: 3.2,
          dr: 5.8,
          L0: 3.2,
          elab: 0.4,
          altpor: 2.1,
          larpor: 1.5,
          proppb: 4.0,
        }
        return {
          ...removeTempIdFromObject(room),
          barriers,
          labirinto,
          porta,
        }
      })

      const payload = { ...this.form, Rooms: roomsToSend, HDR: hdrToSend }

      // log assembled payload
      // eslint-disable-next-line no-console
      // console.log('Submit payload:', JSON.stringify(payload, null, 2))

      // optionally call upsertProject:
      this.saving = true
      try {
        const { id } = this.$route.params
        if (!id || id === 'new') {
          await this.$store.dispatch(
            'project/generateMultipleReport',
            { payload },
          )
        } else {
          await this.$store.dispatch(
            'project/updateMultipleReport',
            { id, payload },
          )
        }
        this.showAlert(this.$t('projectUpsertForm.methods.onSubmit.alert'), 'success')
        this.$router.push({ name: 'pages-project-multi' })
      } catch (err) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            ...this.$t('projectUpsertForm.upsertdErrorToast'),
            icon: 'XIcon',
            variant: 'danger',
          },
        })
      } finally { this.saving = false }
    },

    addProjectRoom() {
      this.Rooms.push({
        id: null, // ou gerado dinamicamente caso seu backend exija
        fabric: 'Varian',
        modelo: 'Halcyon',
        emax: 6,
        egamma: 6,
        eelet: '---',

        pac_dia: '100',
        cp_pac: '4',
        dose: '0.58',
        wfis: '41',
        beam_stop: '1',
        leak: '1.0e-3',
        piso: '1',
        imrt: '100',
        c_imrt: '2.5',
        vmat: '0',
        c_vmat: '2.5',
        tbi: '0',
        npac_tbi: '1',
        dose_tbi: '12',
        dx_tbi: '4.0',
        npts_pri: '5',
        npts_sec: '10',
        pdir_sl: '4.0',
        pdir_lb: '4.0',
        cmax: '0.28',
        ceq: '0.28',
        causa: 'O campo máximo é limitado a 28 cm na diagonal.',
        concreto: '650',
        chumbo: '10',
        bpe: '30',
        f_cm2: '1600',
        alpha: '10000',
        tv: '1000',
        densidade: '2.35',

        labirinto: {
          L: 'Labirinto',
          esp_lab: 1.1,
          planta: 1.1,
        },
        porta: {
          area: 'Livre',
          limite: '2.0e-5',
          nr_fontes: 2,
          tden: 8,
          dp: 4.5,
          dr: 7.9,
          dz: 3.2,
          ds: 0.0,
          L0: 2.2,
          L1: 3.8,
          Ls: 0.0,
          theta0: 32.0,
          thetaz: 31.0,
          thetas: 0.0,

          dsec1: 5.4,
          dzz1: 6.8,
          L1_1: 3.5,
          theta1_1: 46.0,
          dsec2: 5.4,
          dzz2: 6.8,
          L1_2: 3.5,
          theta1_2: 46.0,

          dlab: 5.9,
          d1: 5.7,
          d2: 7.7,
          s0: 3.1,
          s1: 2.15,
          sr: 312.2,
          npor: 0.25,
          altpor: 2.1,
          larpor: 1.5,
          prop_pb: 6.0,
          prop_hbe: 0.0,
        },
      })
    },
    addProjectRoomHDR() {
      this.HDR.push({
        id: null, // ou gerado dinamicamente caso seu backend exija
        fabric: 'Varian',
        modelo: 'GammaMed Plus',
        atividade: 10,
        kerma: 0.48,
        fatConv: 8.76e-3,

        pacSem: 5,
        insercoes: 4,
        tempoIns: 15,
        wfis: 0.05,
        npts: 5,
        pdirsl: 3.45,
        pdirlb: 3.45,
        concreto: 600.0,
        chumbo: 5.0,
        alpha: 10000,
        TV: 1000,
        densidade: 2.35,

        labirinto: {
          L: 'Labirinto de entrada da sala',
          esp_lab: 0.4,
          planta: 0.0,
        },
        porta: {
          limite: '2.0e-5',
          df: 4.2,
          dp: 3.2,
          dr: 5.8,
          L0: 3.2,
          elab: 0.4,
          altpor: 2.1,
          larpor: 1.5,
          proppb: 4.0,
        },
      })
    },
  },
}
</script>

<style>
  @media (max-width: 767px){
    .nav-pills{
      display: block;
    }
    .small-devices-display{
      display: block;
    }
  }
  .flex-description-row {
    display: flex;
    align-items: center;
    align-content: center;
  }
</style>
